import React from "react";
import Select from 'react-select'
import LANGUAGES from "../../../Helpers/Languages";

function Language() {

    const options =[
        {value:"None Selected", label: "None Selected"},
    ];

    LANGUAGES.map((language) => {
        
    })

  return (<div className="filter">
    <h3 className="language-heading">Language</h3>
    <Select options={options} value={options.value} defaultValue={options[0]}/>
  </div>);
}

export default Language;
